import { render, staticRenderFns } from "./copd.vue?vue&type=template&id=27a1a9e6&scoped=true"
import script from "./copd.vue?vue&type=script&lang=js"
export * from "./copd.vue?vue&type=script&lang=js"
import style0 from "./copd.vue?vue&type=style&index=0&id=27a1a9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1a9e6",
  null
  
)

export default component.exports